"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Throttler = /*#__PURE__*/function () {
  function Throttler(cb) {
    (0, _classCallCheck2.default)(this, Throttler);
    this.cb = cb;
    this.cb({
      isProcessing: false,
      isProcessed: false,
      isComplete: false,
      isError: false
    });
  }

  (0, _createClass2.default)(Throttler, [{
    key: "execute",
    value: function execute(promise) {
      var _this = this;

      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 700;
      this.cb({
        isProcessing: true,
        isProcessed: false,
        isComplete: false,
        isError: false
      }); // NOTE: this is exposed only for testing and should not be used outside of that context

      this._executedPromise = Promise.all([promise, new Promise(function (resolve) {
        return setTimeout(resolve, delay);
      })]).then(function () {
        return _this.cb({
          isProcessing: false,
          isProcessed: true,
          isComplete: true,
          isError: false
        });
      }).catch(function () {
        return _this.cb({
          isProcessing: false,
          isProcessed: false,
          isComplete: true,
          isError: true
        });
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.cb({
        isProcessing: false,
        isProcessed: false,
        isComplete: false,
        isError: false
      });
    }
  }]);
  return Throttler;
}();

var _default = {
  create: function create(cb) {
    return new Throttler(cb);
  }
};
exports.default = _default;